import type { TaskHistoryEntry } from '@fos/shared/contracts/work';
import { HISTORY_LONG_TEXT_FIELDS } from '@fos/shared/labels';
import { HistoryList } from '../../history';

/**
 * Historia zmian zadania (audit_log): wspólny komponent HistoryList (kto, co, kiedy; „Status: W toku → Do odbioru”).
 * Dane z karty zadania (`TaskDetail.history`), więc odświeżają się razem z kartą; opis — tylko „zmieniono”.
 */
export function TaskHistory({ entries }: { entries: TaskHistoryEntry[] }) {
  return (
    <HistoryList
      entries={entries.map((e) => ({
        ...e,
        changes: e.changes.map((c) => (HISTORY_LONG_TEXT_FIELDS.has(c.field) ? { ...c, hidden: true } : c)),
      }))}
    />
  );
}
